import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FC } from "react";
import { AllMounth, idTypeInBDD } from "../../../../constants/Constants";
import { cellStyle } from "../../parametrage/Pays/RowPays";
import {
  ICommissionCommerciauxDRC,
  IHerArticleWithCommission,
} from "./ICommissionCommerciauxDRC";

interface SecondNiveauCommissionProps {
  article: IHerArticleWithCommission;
}

const SecondNiveauCommission: FC<SecondNiveauCommissionProps> = ({
  article,
}) => {
  return (
    <TableRow>
      <TableCell style={cellStyle} align="center">
        {article?.client}
      </TableCell>
      <TableCell style={cellStyle} align="center">
        {article?.operation}
      </TableCell>
      <TableCell style={cellStyle} align="center">
        {article?.articles}
      </TableCell>
      <TableCell style={cellStyle} align="center">
        {AllMounth.find((x) => x.id === article?.Mois)?.mounth} {" "}
        {article?.Annee}
      </TableCell>
      <TableCell style={cellStyle} align="center">
        {article?.type}
      </TableCell>
      <TableCell style={cellStyle} align="center">
        {article?.ca && Number(article?.ca).toFixed(2)} -{" "}
        {article?.code_iso ?? "Pas De Devise Facturation"}
      </TableCell>
      <TableCell style={cellStyle} align="center">
        {article?.taux_commission} {" "} %
      </TableCell>
      <TableCell style={cellStyle} align="center">
        {`${article?.Commission && Number(article?.Commission).toFixed(2)} - ${article?.Commission_Devise}`}
      </TableCell>
    </TableRow>
  );
};

export default SecondNiveauCommission;
